/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentProtocolFollowup } from './IncidentProtocolFollowup';
import {
    IncidentProtocolFollowupFromJSON,
    IncidentProtocolFollowupFromJSONTyped,
    IncidentProtocolFollowupToJSON,
} from './IncidentProtocolFollowup';
import type { IncidentProtocolParty } from './IncidentProtocolParty';
import {
    IncidentProtocolPartyFromJSON,
    IncidentProtocolPartyFromJSONTyped,
    IncidentProtocolPartyToJSON,
} from './IncidentProtocolParty';

/**
 * 
 * @export
 * @interface IncidentProtocolActionUpdateRequest
 */
export interface IncidentProtocolActionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    incident_setting_action_type_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    deadline?: string;
    /**
     * 
     * @type {Array<IncidentProtocolParty>}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    responsible_parties?: Array<IncidentProtocolParty>;
    /**
     * 
     * @type {Array<IncidentProtocolFollowup>}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    followups?: Array<IncidentProtocolFollowup>;
    /**
     * 
     * @type {any}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    complete_followups?: any | null;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolActionUpdateRequest
     */
    incomplete_followup_time?: string;
}

/**
 * Check if a given object implements the IncidentProtocolActionUpdateRequest interface.
 */
export function instanceOfIncidentProtocolActionUpdateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IncidentProtocolActionUpdateRequestFromJSON(json: any): IncidentProtocolActionUpdateRequest {
    return IncidentProtocolActionUpdateRequestFromJSONTyped(json, false);
}

export function IncidentProtocolActionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentProtocolActionUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incident_setting_action_type_id': !exists(json, 'incident_setting_action_type_id') ? undefined : json['incident_setting_action_type_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'deadline': !exists(json, 'deadline') ? undefined : json['deadline'],
        'responsible_parties': !exists(json, 'responsible_parties') ? undefined : ((json['responsible_parties'] as Array<any>).map(IncidentProtocolPartyFromJSON)),
        'followups': !exists(json, 'followups') ? undefined : ((json['followups'] as Array<any>).map(IncidentProtocolFollowupFromJSON)),
        'complete_followups': !exists(json, 'complete_followups') ? undefined : json['complete_followups'],
        'incomplete_followup_time': !exists(json, 'incomplete_followup_time') ? undefined : json['incomplete_followup_time'],
    };
}

export function IncidentProtocolActionUpdateRequestToJSON(value?: IncidentProtocolActionUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'incident_setting_action_type_id': value.incident_setting_action_type_id,
        'name': value.name,
        'description': value.description,
        'deadline': value.deadline,
        'responsible_parties': value.responsible_parties === undefined ? undefined : ((value.responsible_parties as Array<any>).map(IncidentProtocolPartyToJSON)),
        'followups': value.followups === undefined ? undefined : ((value.followups as Array<any>).map(IncidentProtocolFollowupToJSON)),
        'complete_followups': value.complete_followups,
        'incomplete_followup_time': value.incomplete_followup_time,
    };
}

